import React from "react";
import { Box, Text, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import theme from "../../theme";
import "./chartStyles.css";

const Chart = ({ data, title, caption }) => {
  const dataWithPercentage = data.map((item) => ({
    ...item,
    percent: ((item.value / data.reduce((acc, curr) => acc + curr.value, 0)) * 100).toFixed(2),
  }));
  const bgColor = useColorModeValue('chart-box', 'chart-box-dark');
  const chartColors = Object.values(theme.colors.chartColors);
  const dividerColor = useColorModeValue(theme.colors.dividerColor.light, theme.colors.dividerColor.dark);

  return (
    <Box className={`${bgColor} chart-hover-effect`}>
      <Text mb={3} fontSize="xl" fontWeight="600">
        {title}
      </Text>
      <Text >
        {caption}
      </Text>
      <Box className="divider"></Box>
      <Box className="chart-pie-legend" display="flex" flexDirection={{ base: 'column', md: 'row' }} alignItems="center" mt={4}>
        <ResponsiveContainer width="60%" height={300} minWidth="200px">
          <PieChart>
            <Pie
              data={dataWithPercentage}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={100}
              dataKey="value"
              nameKey="name"
              stroke="none"
            >
              {dataWithPercentage.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={chartColors[index % chartColors.length]} />
              ))}
            </Pie>
            <Tooltip
              labelFormatter={(label) => {
                return (
                  <span className={'tooltip-title'} >
                  {label ? label : ''}
                </span>
                );
              }}
            />
          </PieChart>
        </ResponsiveContainer>
        <Box className="chart-pie-legend">
          <SimpleGrid columns={2} spacing={3} minWidth="250px" width="100%">
            {dataWithPercentage.map((entry, index) => (
              <React.Fragment key={index}>
                <Box display="flex" alignItems="center" minWidth="120px">
                  <Box
                    className="legend-bullet"
                    backgroundColor={chartColors[index % chartColors.length]}
                    mr={2}
                  />
                  <Text className="legend-text">
                    {entry.name}
                  </Text>
                </Box>
                <Text fontSize="md" color={useColorModeValue("#615E83", "#D1D1D1")}>
                  {entry.percent}%
                </Text>
              </React.Fragment>
            ))}
          </SimpleGrid>
        </Box>
      </Box>
    </Box>
  );
};

export default Chart;
